/* Lamps Expo (2026-10-17): when a shopper picks a choice that doesn't exist together with the other current choices
   (e.g. Matte White finish while "Clear Crystal Beads" is still selected), switch the other dropdowns to a combination
   that exists, preferring one in stock and keeping as many current choices as possible. */
(function () {
  if (window.__lxAutoSelect) return;
  window.__lxAutoSelect = true;
  var cache = {}, busy = false;
  function product(vs) {
    var u = vs.getAttribute('product-url');
    if (!u) return Promise.resolve(null);
    if (!cache[u]) cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[u];
  }
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (busy || !sel || !sel.matches || !sel.matches('select[data-variant-option]')) return;
    var vs = sel.closest('variant-selection');
    if (!vs) return;
    var selects = Array.prototype.slice.call(vs.querySelectorAll('select[data-variant-option]'));
    if (selects.length < 2) return;
    var idx = parseInt(sel.getAttribute('data-variant-option-index'), 10) || 0;
    product(vs).then(function (p) {
      if (!p || !p.variants) return;
      var cur = selects.map(function (s) { return s.value; });
      var exists = p.variants.some(function (v) { return v.options.every(function (o, i) { return o === cur[i]; }); });
      if (exists) return;
      var cands = p.variants.filter(function (v) { return v.options[idx] === cur[idx]; });
      if (!cands.length) return;
      function score(v) { return (v.available ? 100 : 0) + v.options.filter(function (o, i) { return o === cur[i]; }).length; }
      cands.sort(function (a, b) { return score(b) - score(a); });
      var best = cands[0];
      busy = true;
      try {
        selects.forEach(function (s, i) {
          if (i !== idx && s.value !== best.options[i]) {
            s.value = best.options[i];
            s.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } finally { busy = false; }
    });
  });
})();
